import { appendToTracking } from 'Tracker'
import Confirm from '../ActiveVideo/Confirm'

export default appendToTracking(Confirm, 'face_motion')
